module.exports = __webpack_public_path__ + "img/tarj3-6.feeca372.svg";